import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";

/** Centred error/empty page (shadcn-admin error page layout). */
export function ErrorPage({
  code = "404",
  title = "Page not found",
  description = "The page you're looking for doesn't exist or has moved.",
}: {
  code?: string;
  title?: string;
  description?: string;
}): JSX.Element {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-3 p-10 text-center">
      <p className="text-6xl font-bold tracking-tight text-muted-foreground/40">
        {code}
      </p>
      <h1 className="text-2xl font-semibold">{title}</h1>
      <p className="max-w-md text-sm text-muted-foreground">{description}</p>
      <Button asChild className="mt-2">
        <Link to="/">Back to home</Link>
      </Button>
    </div>
  );
}

export function NotFoundPage(): JSX.Element {
  return <ErrorPage />;
}
